import LabelsConfig from './LabelsConfig';
import { resolveProjectLabels } from '../../helpers/adressHelpers/resolveAdressLabels';

/**
 * Instellingen → Portfolio → 'Labels bij projecten': de labels die deze
 * organisatie op een project in het portfolio-overzicht kan zetten. Ze zijn van
 * deze organisatie alleen; andere portfolio's met hetzelfde project zien ze niet.
 * AI-CONTEXT: See src/helpers/portfolio/projectMarks.js
 *
 * @returns {JSX.Element}
 */
const ProjectLabelsConfig = () => (
    <LabelsConfig
        field="ProjectLabels"
        heading="Labels bij projecten"
        intro={"Labels zet je op een project in de kolom 'LABELS' van het portfolio-overzicht, meerdere tegelijk. Alleen jouw organisatie ziet ze."}
        resolve={resolveProjectLabels}
    />
);

export default ProjectLabelsConfig;
